export const AgentSettingsPaths = {
    integrations: "agent-integrations",
    recordings: "agent-recordings",
} as const;
